import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { Cart } from "@spare-cart/contracts/cart";
import { apiClient } from "@core/api";
import { cartKeys } from "@modules/shared";

export const useRemoveCartItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (itemId: string) => apiClient.remove<Cart>(`/cart/items/${itemId}`),
    onSuccess: (cart) => {
      queryClient.setQueryData(cartKeys.detail(), cart);
      void queryClient.invalidateQueries({ queryKey: cartKeys.count() });
    },
  });
};
